import React from 'react'

function FormattedDecimal({ value, color = false, locale = "pl-PL", currency = "" }) {
    let formatter = new Intl.NumberFormat(locale, { style: "decimal" });
    if (currency) {
        formatter = new Intl.NumberFormat(locale, { style: "currency", currency: currency });
    }
    let formattedValue = formatter.format(value);
    let className = "";
    if (color) {
        className = value < 0 ? "text-danger" : "text-success";
    }
    return (<span className={className}>{formattedValue}</span>)
}

export { FormattedDecimal };
